/**
 * @generated SignedSource<<12af5aec906e924d62965b202859d4ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTaxExemption_transaction$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemptionCheckbox_transaction">;
  readonly " $fragmentType": "CheckoutTaxExemption_transaction";
};
export type CheckoutTaxExemption_transaction$key = {
  readonly " $data"?: CheckoutTaxExemption_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemption_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTaxExemption_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemptionCheckbox_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "77002785e57e0cd21d1bd43ba8323395";

export default node;
